/* Routes login */
export const login = "login";

/* Routes Patient */
export const patient = {
	api: {
		register: '/patient/register2',
		exists: '/patient/exists',
	}
};

/* Routes Doctor */
export const doctor = {
	register : "register",
	speciality: {
		list : '/specialities',
		listDoctor : '/doctor/specialities'
	},
	api: {
		facebook: '/doctor/facebook',
		lang: {
			enabled: '/language',
			set: '/language/set',
			trans: '/language/translate'
		},
		register: '/doctor/register',
		exists: '/doctor/exists',
		upload: {
			avatar: '/doctor/avatar',
			office: '/doctor/upload/office',
			subordinate: '/doctor/upload/subordinate'
		},
		list: {
			doctor: '/doctor/doctor',
			office: '/doctor/offices'
		},
		patient: {
			exists: '/patient/exists',
		},
		diary: {
			store: '/diary',
			update: '/diary/'
		},
		comunities: '/doctor/comunities',
		regions: '/doctor/regions',
		offices: '/doctor/offices',
		schedules: '/doctor/schedules',
		turns: '/doctor/schedules/turn',
		extraHours: '/doctor/extra-hours',
		absences: '/doctor/absences',
		search: '/doctor/search',
		tracking: '/doctor/tracking',
		subordinates: '/doctor/subordinates',
		roles: '/doctor/roles',
		bids: '/doctor/bids'
	}
};

/* Routes Public */
export const public_api = {
  api: {
    regions: '/regions',
    cities: '/cities',
    previsions: '/previsions',
    boxes: '/boxes',
    filter: {
      doctor: '/filter/doctor'
    },
    speciality: {
      list: '/specialities'
    },
    diary: {
      getHours: '/diary/getHoursAvailable'
    },
    patient: {
      store: '/patient/register2'
    },
    plans: '/plans',
    indicator: '/indicator/'
  }
}

/* Routes Admin */
export const admin = {
    api: {
        resources: {
          patientTypes: '/admin/type-patients',
          roles: '/admin/roles',
					users: '/admin/users',
					discounts: '/admin/discounts'

				},
				bonuspdf: '/bonuses/pdf/',
				assign: '/assign/available',
				search: '/admin/search',
        restriction: '/admin/restriction',
        countries: '/admin/countries',
				patients: '/admin/patients',
				sellers: '/salesmans',
				workers: '/workers',
				partners: '/partners',
				seller_groups: '/salesmans/groups',
				assign_group: '/salesmans/assign/group',
				assign_clients: '/salesmans/assign/clients',
				create_seller_groups: '/salesmans/groups/create',
				edit_seller_groups: '/salesmans/groups/edit',
				bonuses: '/admin/bonuses',
				benefits: '/admin/benefits',
        regions: '/admin/regions',
				comunities: '/admin/comunities',
				bonustask_types: '/admin/bonustasktypes',
        previsions: '/admin/filter/previsions',
				boxes: '/admin/filter/compensation_boxes',
        patient_totals: '/admin/patients/totals',
        patients_count: '/admin/patients/count',
        patient_remove: '/admin/patients/delete',
        graphics: '/admin/patients/graphics',
        prestators: '/admin/doctors',
        prestators_count: '/admin/doctors/count',
				prestator_remove: '/admin/doctors/delete',
				prestator_comment: '/admin/doctor/comments',

				reserves: '/admin/reserves',
				limits: '/admin/sales_limits',
				integrations: '/integrations',
				create_integration: "/admin/integration",


        reserves_count: '/admin/reserves/count',
				reserve_remove: '/admin/reserves/delete',
				bonuses_totals: '/admin/bonuses/totals',
				bonuses_count: '/admin/bonuses/count',
				bonuses_create: '/admin/bonuses_create',
				benefits_totals: '/admin/benefits/totals',
				bids: '/admin/bids',
				bids_count: '/admin/bids/count',
				bids_details: 'admin/bids/details',
				bids_delete: 'admin/bids/delete/',
        benefits_count: '/admin/benefits/count',
        specialities: '/admin/specialities',
        graphs: '/admin/graphs',
        indicators: '/admin/indicators',
        indicators_graphic: '/admin/indicators/graphic',
        bonus_tasks: '/admin/filter/bonus_tasks',
				bonus_task_types: '/admin/filter/bonus_task_types',
				companies: '/admin/companies',
				companies_count: '/admin/companies/count',
				companies_activate: '/admin/companies/activate'
    }
};

/* Prefix of countries enabled */
export const prefix = ['cl', 'pe', 'ar','mx','co','es', 'us', 'bo','do','cr','ve'];



// WEBPACK FOOTER //
// ./src/config/api.js